let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kspBc")).then(() => parcelRequire('aePlI'));